/**
 * Normalizes a numeric amount to two decimal places (cent rounding).
 * Non-finite or empty values become an empty string for export/display.
 */
export function normalizeAmountTwoDecimals(value: unknown): string {
  if (value === null || value === undefined || value === '') return ''
  const num =
    typeof value === 'number'
      ? value
      : Number(String(value).trim().replace(/,/g, ''))
  if (!Number.isFinite(num)) return ''
  const normalized = Math.round(num * 100) / 100
  return normalized.toFixed(2)
}

export const printCitizenship = (citizenship: string): string => {
  switch (citizenship) {
    case 'us_citizen':
      return 'U.S. Citizen'
    case 'legal_immigrant':
      return 'Lawfully present immigrant'
    case 'other':
      return 'Other'
    default:
      return '-'
  }
}
